import { Directive, HostListener, Input } from '@angular/core';
import { GlobalUtilService } from '@otas/core/services/global-util.service';
import { ToasterService } from '../../services/toaster.service';

@Directive({
    selector: '[download]',
    standalone: false
})
export class DownloadElementDirective {
    @Input() download;
    @Input() type;
    @Input() tableData;

    constructor(private globalUtilService: GlobalUtilService, private toastr: ToasterService) {}

    @HostListener('click')
    async onClick() {
        const isExcel = this.type === 'xlsx';
        if (isExcel) {
            let xlsxData = null;
            if (this.tableData) {
                // For pre-rendered Excel, tableData is already a base64 string
                xlsxData = this.tableData;
            } else {
                // Handle HTML Table capture to Excel
                try {
                    this.toastr.info('Preparing report for download...', 'Download');
                    xlsxData = await this.globalUtilService.captureAsExcel();
                } catch (e) {
                    console.error("Excel capture failed:", e);
                    this.toastr.error('Failed to capture report for download', 'Download Error');
                }
            }

            if (xlsxData) {
                console.log('Downloading Excel file...');
                this.globalUtilService.IPCRendererSend('downloadXLSX', xlsxData);
                this.toastr.success('Download started', 'Download');
            } else {
                console.warn("No data available for Excel download");
                this.toastr.warning('No data available for download', 'Download');
            }
        } else {
            // For PDF
            let pdfData = null;
            if (this.tableData) {
                // For pre-rendered PDF, tableData is a Uint8Array, convert to base64
                pdfData = btoa(new Uint8Array(this.tableData).reduce(function (data, byte) {
                    return data + String.fromCharCode(byte);
                }, ''));
            } else {
                try {
                    this.toastr.info('Preparing report for download...', 'Download');
                    const table = document.querySelector('section.widget table') as HTMLTableElement;
                    if (table) {
                        const orgName = document.querySelector('app-report-header h2')?.textContent?.trim() || '';
                        const templeAddress = document.querySelector('app-report-header h4 i')?.textContent?.trim() || '';
                        const reportNameEl = document.querySelectorAll('app-report-header h4')[1] || document.querySelectorAll('app-report-header h4')[0];
                        const reportName = reportNameEl?.textContent?.trim() || 'Report';
                        pdfData = await this.globalUtilService.captureTableAsVectorPDF(table, reportName, templeAddress, orgName);
                    } else {
                        pdfData = await this.globalUtilService.captureAsPDF();
                    }
                } catch (e) {
                    console.error("Capture failed:", e);
                    this.toastr.error('Failed to capture report for download', 'Download Error');
                }
            }

            if (pdfData) {
                console.log('Downloading PDF file...');
                this.globalUtilService.IPCRendererSend('downloadPDF', pdfData);
                this.toastr.success('Download started', 'Download');
            } else {
                console.warn("No data available for download");
                this.toastr.warning('No data available for download', 'Download');
            }
        }
    }

}
